import { useInView } from "../hooks/useInView";
import { Phone, Mail, MapPin } from "lucide-react";

const MAPS_EMBED =
  "https://maps.google.com/maps?q=Silver+Line+Homeo+Care&t=&z=20&ie=UTF8&iwloc=&output=embed";

export default function Contact() {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div
          className="text-center mb-12"
          ref={ref}
          style={{
            opacity: inView ? 1 : 0,
            transform: inView ? "translateY(0)" : "translateY(25px)",
            transition: "opacity 0.6s ease, transform 0.6s ease",
          }}
        >
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary mb-3">
            Reach Us
          </span>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-darktext mb-4">
            Contact Us
          </h2>
          <p className="text-gray-600 max-w-xl mx-auto text-sm sm:text-base">
            We're here to answer your questions and help you begin your healing journey.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {/* Info column */}
          <div className="flex flex-col gap-6">
            {/* Email */}
            <div
              className="bg-lightbg rounded-2xl p-6 flex items-start gap-4 hover:shadow-md transition-shadow"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateX(0)" : "translateX(-20px)",
                transition: "opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s",
              }}
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider mb-1">
                  Email
                </div>
                <a
                  href="mailto:silverlinehomeo@gmail.com"
                  className="text-darktext font-semibold hover:text-primary transition-colors text-sm"
                >
                  silverlinehomeo@gmail.com
                </a>
                <div className="mt-3">
                  <a
                    href="mailto:silverlinehomeo@gmail.com"
                    className="inline-flex items-center gap-1.5 bg-primary hover:bg-darktext text-white text-xs font-semibold px-4 py-2 rounded-full transition-all duration-300 hover:scale-105"
                  >
                    <Mail className="w-3.5 h-3.5" />
                    Email Us
                  </a>
                </div>
              </div>
            </div>

            {/* Phone */}
            <div
              className="bg-lightbg rounded-2xl p-6 flex items-start gap-4 hover:shadow-md transition-shadow"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateX(0)" : "translateX(-20px)",
                transition: "opacity 0.5s ease 0.2s, transform 0.5s ease 0.2s",
              }}
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Phone className="w-5 h-5 text-primary" />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider mb-1">
                  Phone
                </div>
                <a
                  href="tel:+919890900292"
                  className="text-darktext font-semibold hover:text-primary transition-colors text-sm"
                >
                  +91-98-90-900-292
                </a>
              </div>
            </div>

            {/* Address */}
            <div
              className="bg-lightbg rounded-2xl p-6 flex items-start gap-4 hover:shadow-md transition-shadow"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateX(0)" : "translateX(-20px)",
                transition: "opacity 0.5s ease 0.3s, transform 0.5s ease 0.3s",
              }}
            >
              <div className="w-11 h-11 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <MapPin className="w-5 h-5 text-primary" />
              </div>
              <div>
                <div className="text-xs text-gray-500 font-medium uppercase tracking-wider mb-1">
                  Address
                </div>
                <address className="text-darktext text-sm not-italic leading-relaxed">
                  Silver Line Homeopathy Clinic,<br />
                  101, 1st Floor, Janki Crystal,<br />
                  Opposite Talegaonkar Hardware,<br />
                  Vikas Nagar, Dehu Road,<br />
                  Maharashtra 412101
                </address>
              </div>
            </div>
          </div>

          {/* Map column */}
          <div
            className="rounded-2xl overflow-hidden shadow-md border border-green-100"
            style={{
              opacity: inView ? 1 : 0,
              transform: inView ? "translateX(0)" : "translateX(20px)",
              transition: "opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s",
              minHeight: "400px",
            }}
          >
            <iframe
              title="Silver Line Homeo Care Location"
              src={MAPS_EMBED}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px", display: "block" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
